/* eslint-disable no-console -- intentional debug output gated by `enabled` flag, disabled by default in production */

const LS_KEY = "todas_push_logger_enabled";
const PREFIX = "[PushLogger]";

let enabled = localStorage.getItem(LS_KEY) === "true";

declare global {
  interface Window {
    enablePushLogger: () => void;
    disablePushLogger: () => void;
  }
}

export const pushLogger = {
  log: (msg: string, ...args: unknown[]) => {
    if (enabled) console.log(`${PREFIX} ${msg}`, ...args);
  },
  warn: (msg: string, ...args: unknown[]) => {
    if (enabled) console.warn(`${PREFIX} ${msg}`, ...args);
  },
  error: (msg: string, ...args: unknown[]) => {
    if (enabled) console.error(`${PREFIX} ${msg}`, ...args);
  },
};

window.enablePushLogger = () => {
  enabled = true;
  localStorage.setItem(LS_KEY, "true");
  console.info(`${PREFIX} enabled — disablePushLogger() to turn off`);
};

window.disablePushLogger = () => {
  enabled = false;
  localStorage.removeItem(LS_KEY);
  console.info(`${PREFIX} disabled`);
};

if (enabled) {
  console.info(`${PREFIX} active — disablePushLogger() to turn off`);
}
